export const accompaniedProgramData = {
  title: "Doprovodný program",
  agendaItems: [
    {
      subtitle: "slavnostní zahájení srazu",
      descriptions: [
        "Pá - uvítání účastníků srazu, zdravice vzácných hostů",
        "hudební vystoupení kapely Kaj Hrajem"
      ],
      src: "/images/program/turisticka-kapela-Kaj-Hrajem.JPG"
    },
    {
      subtitle: "beseda",
      descriptions: [
        "So - beseda o historii Hlučínska - přednáší historik z Muzea Hlučínska",
      ],
    },
    {
      subtitle: "koncerty",
      descriptions: [
        "Pá - koncert folkové skupiny Forfolk",
        "So - folklorní večer",
      ],
    },
    {
      subtitle: "společenský večer",
      descriptions: [
        "Ne - tradiční puchýřovská zábava",
        "předání pořadatelské štafety",
      ],
      src: "/images/program/tanecni-zabava.jpg"
    },
    {
      subtitle: "zimní táboření",
      descriptions: [
        "Pá - Po - zimní táboření u pevnosti Jaroš v Darkovičkách",
      ],
      src: "/images/program/zimni-taboreni.jpg"
    },
    {
      subtitle: "Svařák Fest",
      descriptions: [
        "akci organizuje Sport a kultura Hlučín, příspěvková organizace",
        "So - soutěž o nejlepší svařené víno",
        "cimbálová muzika"
      ],
    },
    {
      subtitle: "farmářské trhy",
      descriptions: [
        "akci organizuje Sport a kultura Hlučín, příspěvková organizace",
        "Ne - prezentace regionálních produktů k nákupu suvenýrů i k občerstvení"
      ],
    },
    {
      subtitle: "výstava o historii KČT",
      descriptions: [],
    },
    {
      subtitle: "Komentované prohlídky podkroví kostela sv. Jana Křtitele",
      descriptions: [
        "Pá - Po - dle otevírací doby"
      ],
      src: "/images/program/vez-krtitele.jpg"
    },
    {
      subtitle: "Komentované prohlídky Hlučína",
      descriptions: [
        "Po - ve spolupráci s Muzeem Hlučínska a TIC Hlučín"
      ],
    },
  ]
};